var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"content"},[_c('section',{staticClass:"content-wrapper"},[_c('ModuleA'),_c('ModuleB'),_c('ModuleC'),_c('ModuleD'),_c('ModuleE'),_c('ModuleF'),_c('ModuleG'),_c('ModuleH'),_c('ModuleI'),_c('ModuleJ'),_c('HomeFooter')],1),_c('PriceOffCountdown')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }